<div class="recipient-div">
    <mat-card *ngIf="!disabled" class="form-card">
        <mat-card-header>
            <mat-card-title>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.RECIPIENTS.NEW_ITEM' | translate
                }}</mat-card-title>
            <div class="action-buttons">
                <button mat-raised-button color="primary" (click)="add()" [disabled]="formGroup.invalid"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.RECIPIENTS.ADD_ITEM' | translate">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="formGroup">
                <mat-form-field class="w100">
                    <input type="text" matInput formControlName="search" [matAutocomplete]="auto"
                        [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate">
                    <div matSuffix class="app-suffix-search-icon-wrapper">
                        <button mat-icon-button (click)="search()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)="addGaudeRecipient($event.option.value)">
                        <mat-option *ngFor="let recipient of options" [value]="recipient"
                            [ngStyle]="isSelected(recipient, 'search') ? { 'background-color': '#f0f8ff'} : {}">
                            {{recipient.nombre}} - {{recipient.email_deusto}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formGroup.get('search').hasError('minlength')">
                        {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.RECIPIENTS.MIN_LENGTH' | translate }}
                    </mat-error>
                </mat-form-field>

                <div class="spinner-center" *ngIf="loading">
                    <mat-spinner></mat-spinner>
                </div>
                <div *ngIf="!loading" class="formDiv">
                    <mat-form-field class="w100">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.NAME' | translate
                            }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="name"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w100">
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.EMAIL' | translate
                            }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="email"></textarea>
                    </mat-form-field>

                    <mat-form-field *ngIf="formGroup.get('unit').value" class="w100" >
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.UNIT' | translate
                            }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="unit"></textarea>
                    </mat-form-field>

                    <mat-form-field *ngIf="formGroup.get('gaudeId').value" class="w100" >
                        <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.ID' | translate
                            }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="gaudeId"></textarea>
                    </mat-form-field>

                    <mat-button-toggle-group formControlName="toNotify" class="mt10">
                        <mat-button-toggle color="primary" [value]="false">{{
                            'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.TRANSFER' |
                            translate }}</mat-button-toggle>
                        <mat-button-toggle color="primary" [value]="true">{{
                            'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.NOTIFY' | translate
                            }}</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <form [formGroup]="group" [ngClass]="!disabled ? 'w50' : 'w100'" *ngIf="formArray.controls.length > 0">
        <div [formArrayName]="controlName">
            <mat-accordion>
                <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index" [formGroupName]="i">
                    <mat-expansion-panel #panel class="expansion-panel"
                        [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{control.get('name').value}}</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon>{{ control.get('gaudeId').value ? 'assignment_ind' : 'person' }}</mat-icon>
                                <mat-icon *ngIf="false" fontSet="material-icons-outlined">{{ control.get('toNotify').value ? 'notifications' : 'present_to_all' }}</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
        
                        <div class="div-wrap">
                            <mat-form-field class="w100">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.NAME' |
                                    translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="name"></textarea>
                            </mat-form-field>

                            <mat-form-field class="w100">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.EMAIL' |
                                    translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="email"></textarea>
                            </mat-form-field>

                            <mat-form-field *ngIf="control.get('unit').value" class="w100">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.UNIT' |
                                    translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="unit"></textarea>
                            </mat-form-field>

                            <mat-form-field *ngIf="control.get('gaudeId').value" class="w100">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.ID' |
                                    translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="gaudeId"></textarea>
                            </mat-form-field>

                            <mat-button-toggle-group formControlName="toNotify" class="mt10">
                                <mat-button-toggle color="primary" [value]="false">{{
                                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.TRANSFER' |
                                    translate }}</mat-button-toggle>
                                <mat-button-toggle color="primary" [value]="true">{{
                                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.FIELDS.PROGRAMMING.RECIPIENTS.NOTIFY' | translate
                                    }}</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
        
                        <div class="action-buttons" *ngIf="!disabled">
                            <button mat-raised-button color="warn" (click)="delete(i)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.RECIPIENTS.DELETE_ITEM' | translate">
                                <mat-icon>delete</mat-icon> {{ 'APP.ACTIONS.DELETE' | translate }}
                            </button>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </form>

    <mat-card *ngIf="formArray.controls.length == 0" class="center">
        <mat-card-content>
            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.STEPS.RECIPIENTS.EMPTY_ITEM' | translate }}
        </mat-card-content>
    </mat-card>
</div>